import { useEffect, useMemo, useRef, useState } from 'react'
import {
  Alert,
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  notification,
  Row,
  Spin,
  Tooltip
} from 'antd'
import { CustomSelect } from 'src/components/common/select'
import { useTranslation } from 'react-i18next'
import { CollapseBlock } from 'src/components/common/other/CollapseBlock'
import { AddComment } from 'src/components/common/button/AddComment'
import classApi from 'src/api/classApi'
import { useGetData } from 'src/hooks/useGetData'
import { Comments } from 'src/components/class/demo/edit/Comments'
import {
  CATEGORY_TYPE,
  GRADES_HAVE_WEEK_STUDYING,
  minSessionPerWeek,
  URL_TEMPLATE,
  USER_ROLES_ENUM
} from 'src/libs/constant'
import { getDateV2, getSearchQuery, isPastTimeV2 } from 'src/libs/util'
import { currentDateWithTimezone, timeConvertHHmm } from 'src/libs/date'
import { useGetUserOptionsByRole } from 'src/hooks/useGetUserOptionsByRole'
import moment from 'moment'
import startOfDay from 'date-fns/startOfDay'
import sessionApi from 'src/api/sessionApi'
import { useGetCategories } from 'src/hooks/useGetCategories'
import { useGetCategoryOptions } from 'src/hooks/useGetCategoryOptions'
import userApi from 'src/api/userApi'
import useGetHourOptionsByType from 'src/hooks/useGetHourOptionsByType'
import { useModalState } from 'src/hooks/useModalState'
import { trackSessionModalAction } from 'src/components/class/regular/edit/SessionTrackControl'
import { useGetCategories as useGetCategoriesV2 } from 'src/hooks/useGetCategoriesV2'
import { uniqBy } from 'lodash'
import { useRouter } from 'next/router'
import useCreateUserOptionsWithDefaultValue from 'src/hooks/useCreateUserOptionsWithDefaultValue'
import { ModalForm } from '../../modal/ModalForm'
import ModalSelectTeacherOfSession from '../components/ModalSelectTeacherOfSession'
import useGetWithContext from 'src/hooks/useGetWithContext'
import { useGetClassroomOptionsNotRole } from 'src/hooks/useGetClassroom'
import copy from 'copy-to-clipboard'
import { CopyOutlined } from '@ant-design/icons'
import Link from 'next/link'
import { colorClassInStatus } from 'src/libs/constant/class-regular/classRegular'
import { isShowButtonEnterClass } from 'src/components/common/button/EnterClassInButton'
import useGetPhoneClassInVirtual from 'src/hooks/useGetPhoneClassInVirtual'
import { SCHEDULE_TYPE } from 'src/libs/constant/calendar'

const { TextArea } = Input

export function SessionInfo ({ classData, handleReload, validationValues, serverRuntimeConfig }) {
  const router = useRouter()
  const [editable, setEditable] = useState(false)
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const resetFormValues = useRef({})
  const latestTeacherSchedule = useRef()
  const [isSubmitting, setSubmitting] = useState(false)
  const [teacherSchedule, setTeacherSchedule] = useState()
  const [scheduleDate, setScheduleDate] = useState()
  const [classTimeSlotId, setClassTimeSlotId] = useState()
  const [filterTeacher, setFilterTeacher] = useState()
  const modalContent = useRef(null)
  const { handleClose, handleOpen, isModalVisible } = useModalState()
  const content = modalContent.current
  const [noteChangeTeacher, setNoteChangTeacher] = useState()
  const [waitingConfirmId, setWaitingConfirmId] = useState(false)
  const { id } = getSearchQuery()
  const [loadingChangeTeacher, setLoadingChangeTeacher] = useState(false)
  const { getCategoryData: getTimeSlot } = useGetCategoriesV2(CATEGORY_TYPE.CLASS_TIME_SLOT)
  const timeSlot = getTimeSlot(classData?.classTimeSlotId)
  const isSessionStarted = isPastTimeV2({ date: classData?.learnDate, time: timeSlot?.startTime })
  const baseUrl = window.location.origin
  const coordinatorOptions = useGetUserOptionsByRole(USER_ROLES_ENUM.MANAGER_TEACHER)

  const studentsFilterRemoved = classData?.students?.filter(student => student.status !== 'REMOVED_STUDENT')
  const studentIds = studentsFilterRemoved?.reduce((acc, item) => {
    if (!acc.includes(item.studentId)) {
      acc.push(item.studentId)
    }
    return acc
  }, [])
  const { data: detailStudyProgram } = useGetWithContext(
    `STUDY_PROGRAM_BY_ID_${classData?.studyProgramId}`,
    sessionApi.studyProgramOfSession,
    classData?.studyProgramId,
    { isDisabled: !classData?.studyProgramId }
  )
  const { centerId = null, classRoomId = null } = classData || {}
  const isCenter = useMemo(() => {
    if (!detailStudyProgram) return false
    return detailStudyProgram?.learningModel === 'OFFLINE'
  }, [detailStudyProgram])
  const { data: regularClass } = useGetData(classApi.detail, classData?.classRegularId, {
    isDisabled: !classData?.classRegularId
  })

  const { categoryOptions: centerOptions } = useGetCategoriesV2(CATEGORY_TYPE.CENTER)
  const centerOptionsActive = useMemo(() => {
    if (!centerOptions) return null
    return centerOptions?.filter(item => item?.status === 'ACTIVE')
  }, [centerOptions])

  const { classRoomOptions } = useGetClassroomOptionsNotRole({ isActive: true, isCode: true })
  const {
    handleOpen: handleOpenTeacher,
    handleClose: handleCloseTeacher,
    isModalVisible: isModalVisibleTeacher
  } = useModalState()

  const {
    handleOpen: handleOpenReasonChangeTeacher,
    handleClose: handleCloseReasonChangeTeacher,
    isModalVisible: isModalVisibleReasonChangeTeacher
  } = useModalState()

  const criteria = useMemo(() => {
    return {
      criteria: [
        {
          field: 'id',
          operator: 'EQUAL',
          value: classData?.id
        }
      ]
    }
  }, [classData])
  const { data: dataSession } = useGetData(sessionApi.listSessionRegular, criteria, { isDisabled: !classData?.id })
  const defaultMonitorId = `${dataSession?.content[0]?.monitorId || dataSession?.content[0]?.initMonitorId || ''}`

  const monitorOptions = useGetUserOptionsByRole(USER_ROLES_ENUM.EMPLOYEE_MONITOR)
  const { selectorProps } = useCreateUserOptionsWithDefaultValue({
    options: monitorOptions,
    defaultValue: defaultMonitorId,
    defaultUserCacheKey: `GET_USER_BY_ID_${defaultMonitorId}`
  })

  const studyProgramOptions = useGetCategoryOptions(CATEGORY_TYPE.STUDY_PROGRAM)

  const regularTimeOptions = useGetHourOptionsByType(detailStudyProgram?.scheduleType, true)
  const backupTimeOptions = useGetHourOptionsByType('BACKUP', true)

  const sessionTimeOptions = useMemo(() => {
    return uniqBy(regularTimeOptions.concat(backupTimeOptions), 'id')
  }, [regularTimeOptions?.length, backupTimeOptions?.length])

  const timeList = useGetCategories(CATEGORY_TYPE.CLASS_TIME_SLOT)
  const gradeList = useGetCategories(CATEGORY_TYPE.GRADE)
  const levelList = useGetCategories(CATEGORY_TYPE.LEVEL)
  const gradeCode = gradeList?.find((val) => val.id === classData?.gradeId)?.code

  const isWeekOfGrade = useMemo(() => {
    return GRADES_HAVE_WEEK_STUDYING.some((grade) => grade === gradeCode)
  }, [gradeCode])

  const handleOpenModalReasonChangeTeacher = () => {
    setLoadingChangeTeacher(true)
    const dataStatus = classApi.checkTeacherStatusWaitingConfirm(id, classData?.teacherId)
    dataStatus.then((res) => {
      setWaitingConfirmId(res.data.id)
      setLoadingChangeTeacher(false)
      if (res.data.status === 'SENT_CONFIRM' || res.data.status === 'CONFIRMED') {
        handleOpenReasonChangeTeacher()
      } else {
        handleOpenModalTeacher()
      }
    })
  }

  const handleOpenModalTeacher = () => {
    setFilterTeacher({ scheduleDate, classTimeSlotId, grades: gradeCode })
    handleOpenTeacher()
  }

  useEffect(() => {
    if (regularClass) {
      const { code } = regularClass
      code && form.setFieldsValue({ ...form.getFieldsValue(), code })
    }
  }, [regularClass])

  const criteriaTeacherSchedule = useMemo(() => {
    const startTime = timeList?.find((i) => i.id === classData?.classTimeSlotId)?.startTime
    return {
      criteria: [
        {
          field: 'scheduleType',
          operator: 'IN',
          values: ['REGULAR', 'BACKUP']
        },
        {
          field: 'status',
          operator: 'IN',
          values: ['ASSIGNED', 'OPEN']
        },
        {
          field: 'scheduleDate',
          operator: 'EQUAL',
          value: Number(moment(getDateV2(classData?.learnDate, timeConvertHHmm(startTime)))?.format('YYYYMMDD')),
          type: 'Int'
        },
        {
          field: 'classTimeSlotId',
          operator: 'EQUAL',
          value: classData?.classTimeSlotId
        },
        {
          field: 'teacherId',
          operator: 'EQUAL',
          value: classData?.teacherId,
          type: 'Int'
        }
      ]
    }
  }, [classData])

  const { data: mainTeacher } = useGetData(userApi.detail, regularClass?.teacherId, {
    isDisabled: !regularClass?.teacherId
  })

  useEffect(() => {
    form.setFieldsValue({ ...form.getFieldsValue(), mainTeacherId: mainTeacher?.userName })
  }, [mainTeacher])

  const { data: responseDataSchedule, statusCode } = useGetData(
    sessionApi.listTeacherSchedule,
    criteriaTeacherSchedule,
    { isDisabled: !classData?.teacherId },
    [classData?.teacherId]
  )

  const dataSchedule = useMemo(() => {
    const responseScheduleTeacherId = responseDataSchedule?.content[0]?.teacherId
    if (responseScheduleTeacherId !== classData?.teacherId) {
      return { content: [] }
    }
    return responseDataSchedule
  }, [responseDataSchedule, classData?.teacherId])

  const queryClassTeacherDetail = useMemo(() => {
    if (!statusCode || !dataSchedule?.content || dataSchedule.content?.length) {
      return null
    }

    if (classData?.teacherId) {
      return { teacherId: classData?.teacherId }
    }

    return null
  }, [classData, statusCode, dataSchedule])

  const { data: teacherDetails } = useGetData(
    userApi.detail,
    queryClassTeacherDetail?.teacherId,
    { isDisabled: !queryClassTeacherDetail },
    [queryClassTeacherDetail]
  )

  useEffect(() => {
    if (!editable) {
      if (dataSchedule?.content?.length) {
        setTeacherSchedule(dataSchedule.content[0])
      } else if (teacherDetails) {
        setTeacherSchedule({ ...teacherDetails, teacherId: teacherDetails.id })
      }
    }
  }, [dataSchedule, teacherDetails, editable])

  useEffect(() => {
    if (!latestTeacherSchedule?.current && dataSchedule) {
      const teacherSchedule = dataSchedule.content[0]
      latestTeacherSchedule.current = teacherSchedule
      setTeacherSchedule(teacherSchedule)
    }
  }, [dataSchedule])

  useEffect(() => {
    if (!scheduleDate || !classTimeSlotId) {
      setTeacherSchedule(null)
    }
  }, [scheduleDate, classTimeSlotId])

  useEffect(() => {
    if (classData) {
      /**
       * Khởi tạo data form, data reset form sau khi data về buổi học được lấy về từ API
       */
      const {
        learnDate: date,
        classTimeSlotId,
        status,
        code: slotCode,
        studyProgramId,
        gradeId,
        levelId,
        weekStudying,
        coordinatorId
      } = classData
      const monitorId =
        resetFormValues.current?.monitorId ||
        dataSession?.content[0]?.monitorId ||
        dataSession?.content[0]?.initMonitorId
      const time = sessionTimeOptions?.find((i) => i.value === classTimeSlotId)?.value
      const startTime = timeList?.find((i) => i.id === classTimeSlotId)?.startTime
      const grade = gradeList?.find((i) => i.id === gradeId)?.name
      const level = levelList?.find((i) => i.id === levelId)?.name
      const classType = `${grade || ''} - ${level || ''}`

      const _scheduleDate = moment(getDateV2(date, timeConvertHHmm(startTime)))

      setScheduleDate(moment(_scheduleDate).format('YYYYMMDD'))
      setClassTimeSlotId(time)
      const formValues = {
        classTimeSlotId: time,
        scheduleDate: _scheduleDate,
        status: status && t(`constant.session_status_ticket.${status}`),
        slotCode,
        weekStudying,
        studyProgramId: studyProgramId || '',
        monitorId: `${monitorId || ''}`,
        coordinatorId: `${coordinatorId || ''}`,
        classType,
        centerId: isCenter && centerId && centerOptionsActive?.some(center => center?.value === centerId) ? centerId : null,
        classRoomId: isCenter && classRoomId && classRoomOptions?.some(classRoom => classRoom?.value === classRoomId) ? classRoomId : null
      }
      resetFormValues.current = {
        ...formValues,
        scheduleDate: moment(_scheduleDate).format('YYYYMMDD')
      }
      form.setFieldsValue(formValues)
    }
  }, [classData, dataSession, sessionTimeOptions])

  const onUndo = () => {
    setTeacherSchedule(latestTeacherSchedule?.current || dataSchedule || {})
    setScheduleDate(resetFormValues.current.scheduleDate)
    setClassTimeSlotId(resetFormValues.current.classTimeSlotId)
    form.setFieldsValue({
      ...resetFormValues.current,
      scheduleDate: resetFormValues.current.scheduleDate ? moment(resetFormValues.current.scheduleDate, 'YYYYMMDD') : null
    })
    setNoteChangTeacher()
  }

  const onFinish = async (values) => {
    const { monitorId, scheduleDate, classTimeSlotId, weekStudying, coordinatorId } = values
    const { id } = classData
    const payload = { id, teacherScheduleId: teacherSchedule?.id, monitorId, weekStudying, coordinatorId }
    if (!teacherSchedule?.id) {
      modalContent.current = (
        <Alert message={t('page.session.text.validate_schedule_id_teacher')} type='warning' showIcon banner />
      )
      return handleOpen()
    }
    setSubmitting(true)

    /**
     * Cần block call request thay đổi thông tin buổi học vì khi đổi giáo viên cần submit lý do đổi giáo viên trước (trong trường hợp đổi giáo viên)
     */
    let isAllowChangeSessionInfo = true

    if (noteChangeTeacher?.note) {
      const { status: statusNoteChangeTeacher } = await classApi.saveNoteChangeTeacher(noteChangeTeacher)
      isAllowChangeSessionInfo = statusNoteChangeTeacher === 200
    }

    if (!isAllowChangeSessionInfo) {
      setSubmitting(false)
      message.error(t('page.class.text.error_submit_reason_change_teacher'))
      return
    }

    const { data: sessionUpdatedData, status } = await sessionApi.editSession(payload)
    setNoteChangTeacher()
    setSubmitting(false)
    if (status === 200) {
      /**
       * Request updated monitor, teacher của buổi học thành công
       * Không thực hiện reload lại API do API Filter (api/calendar/class-regular/session/filter) được sử dụng lấy monitorId của buổi học ko realtime (cached)
       * Thực hiện update thủ công phía client side 2 tham chiếu resetFormValues và sessionData
       * Trường hợp ở các phase khác có thể update nhiều trường khác ngoài teacher, monitor thì nhớ update lại data phía client tại đây
       */
      if (sessionUpdatedData && sessionUpdatedData.id !== classData.id) {
        router.replace(`${window.location.pathname}?id=${sessionUpdatedData?.id}`, null, { shallow: true })
      } else {
        handleReload()
      }
      setEditable(false)
      latestTeacherSchedule.current = teacherSchedule
      resetFormValues.current = {
        ...resetFormValues.current,
        monitorId,
        scheduleDate: moment(scheduleDate).format('YYYYMMDD'),
        classTimeSlotId,
        weekStudying,
        coordinatorId
      }
    }
    if (status === 409) {
      message.destroy()
      modalContent.current = (
        <Alert message={t('page.session.text.duplicate_time_student_error')} type='warning' showIcon banner />
      )
      return handleOpen()
    }
  }

  const handleAddComment = (note) => {
    const { id } = classData
    const payload = { id, note }
    return sessionApi.addCommentSession(payload)
  }
  // const { userRoles } = getUser()
  // const canViewMaterial = hasRequiredItem(userRoles, [USER_ROLES_ENUM.ADMIN, USER_ROLES_ENUM.EMPLOYEE_TEACHER, USER_ROLES_ENUM.MANAGER_TEACHER])
  const { canEditSession, isMakupSession, hasRoleToAssignMonitor } = validationValues

  const code = classData?.code
  const header = (
    <>
      <span>{t('page.class.text.session_info')}</span>&nbsp;
      <strong className='mr-3'>{code}</strong>
      {
        detailStudyProgram?.sessionsPerWeek >= minSessionPerWeek && (
          <span className='learning-assigned-time'>
            {t('page.class.text.learning_assigned_time')} {classData?.ordinalNumberOnWeek}
          </span>
        )
      }
    </>
  )

  const onChangeScheduleDate = (value) => {
    const _scheduleDate = value && moment(value).format('YYYYMMDD')
    setScheduleDate(_scheduleDate)
    setClassTimeSlotId(form.getFieldValue('classTimeSlotId'))
    setTeacherSchedule('')
  }

  const onChangeClassTimeSlotId = (value) => {
    setClassTimeSlotId(value)
    const _scheduleDate = moment(form.getFieldValue('scheduleDate')).format('YYYYMMDD')
    setScheduleDate(_scheduleDate)
    setTeacherSchedule('')
  }

  const { callingCode, phone } = useGetPhoneClassInVirtual(classData?.mgmtClassInAcctId)

  const sessionType = classData?.scheduleType === SCHEDULE_TYPE.DEMO ? SCHEDULE_TYPE.DEMO : SCHEDULE_TYPE.REGULAR

  const ButtonHeader = () => {
    return (
      <>
        <Tooltip
          placement='topRight'
          color='#fff'
          title={t('page.class.text.link_track_time')}
          overlayInnerStyle={{ color: '#111827' }}
          key='track-time'
        >
          <Button
            type='link'
            icon={
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M5 3L2 6M22 6L19 3M6 19L4 21M18 19L20 21M12 9V13L14 15M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z'
                  stroke='#6B7280' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'
                />
              </svg>
            }
            onClick={(e) => {
              e.stopPropagation()
              trackSessionModalAction.openTimeTrack(classData)
            }}
            className='p-0'
          />
        </Tooltip>
        <Tooltip
          placement='topRight'
          title='Video học'
          overlayInnerStyle={{ color: '#111827' }}
          color='#fff'
        >
          <Button
            type='link'
            icon={
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M22 8.93137C22 8.32555 22 8.02265 21.8802 7.88238C21.7763 7.76068 21.6203 7.69609 21.4608 7.70865C21.2769 7.72312 21.0627 7.93731 20.6343 8.36569L17 12L20.6343 15.6343C21.0627 16.0627 21.2769 16.2769 21.4608 16.2914C21.6203 16.3039 21.7763 16.2393 21.8802 16.1176C22 15.9774 22 15.6744 22 15.0686V8.93137Z'
                  stroke='#6B7280' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'
                />
                <path
                  d='M2 9.8C2 8.11984 2 7.27976 2.32698 6.63803C2.6146 6.07354 3.07354 5.6146 3.63803 5.32698C4.27976 5 5.11984 5 6.8 5H12.2C13.8802 5 14.7202 5 15.362 5.32698C15.9265 5.6146 16.3854 6.07354 16.673 6.63803C17 7.27976 17 8.11984 17 9.8V14.2C17 15.8802 17 16.7202 16.673 17.362C16.3854 17.9265 15.9265 18.3854 15.362 18.673C14.7202 19 13.8802 19 12.2 19H6.8C5.11984 19 4.27976 19 3.63803 18.673C3.07354 18.3854 2.6146 17.9265 2.32698 17.362C2 16.7202 2 15.8802 2 14.2V9.8Z'
                  stroke='#6B7280' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'
                />
              </svg>
            }
            style={{ padding: 0 }}
            onClick={(e) => {
              e.stopPropagation()
              trackSessionModalAction.openVideoTrack(classData)
            }}
          />
        </Tooltip>
      </>
    )
  }

  return (
    <CollapseBlock
      header={header}
      editable={editable}
      classData={classData}
      setEditable={canEditSession ? setEditable : undefined}
      onUndo={onUndo}
      canViewMaterial={false}
      ButtonHeaderComponent={ButtonHeader}
      isShowButton={classData?.status === 'DONE' || classData?.status === 'DONE_1' || classData?.status === 'DONE_2'}
      isTooltip
    >
      <Spin spinning={loadingChangeTeacher}>
        <Form {...formItemLayout} initialValues={{}} form={form} onFinish={onFinish}>
          <Row>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              {regularClass?.id && (
                <Form.Item name='code' label='Code'>
                  <Input disabled />
                </Form.Item>
              )}
              <Form.Item name='slotCode' label={t('page.class.label.slot_code')}>
                <Input disabled />
              </Form.Item>
              <Form.Item name='classType' label={t('page.class.label.class_type')}>
                <Input disabled />
              </Form.Item>
              <Form.Item name='studyProgramId' label={t('page.class.label.study_program_name')}>
                <CustomSelect options={studyProgramOptions} disabled allowClear />
              </Form.Item>
              <Form.Item name='status' label={t('page.class.label.status')}>
                <Input disabled />
              </Form.Item>
              {
                (classData?.sessionType === 'MAKE_UP_LESSON' || isWeekOfGrade) && classData?.weekStudying && (
                  <Form.Item
                    name='weekStudying'
                    label={t('page.class.label.learn_week')}
                  >
                    <InputNumber style={{ width: '100%' }} min={0} max={10000} disabled={true} />
                  </Form.Item>
                )
              }
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item label={t('page.session.label.time')}>
                <Row gutter={10}>
                  <Col span={12}>
                    <Form.Item
                      name='scheduleDate'
                      wrapperCol={{ span: 24 }}
                      rules={[
                        {
                          required: true,
                          message: <span>{t('common.text.field_required')}</span>
                        }
                      ]}
                      className='mb-0'
                    >
                      <DatePicker
                        disabled={!isMakupSession || !editable || !hasRoleToAssignMonitor || isSessionStarted}
                        style={{ width: '100%' }}
                        placeholder=''
                        format='DD/MM/YYYY'
                        disabledDate={(current) =>
                          current && current.valueOf() < startOfDay(currentDateWithTimezone()).getTime()}
                        onChange={onChangeScheduleDate}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name='classTimeSlotId'
                      wrapperCol={{ span: 24 }}
                      rules={[
                        {
                          required: true,
                          message: <span>{t('common.text.field_required')}</span>
                        }
                      ]}
                      className='mb-0'
                    >
                      <CustomSelect
                        options={sessionTimeOptions}
                        disabled={
                          !isMakupSession || !editable || !hasRoleToAssignMonitor || !scheduleDate || isSessionStarted
                        }
                        style={{ width: '100%' }}
                        onChange={onChangeClassTimeSlotId}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>
              <Form.Item name='monitorId' label={t('page.class.label.monitor')}>
                <CustomSelect {...selectorProps} disabled={!editable || !hasRoleToAssignMonitor} allowClear />
              </Form.Item>
              <Form.Item name='coordinatorId' label={t('page.class.label.coordinator')}>
                <CustomSelect
                  disabled={!editable || classData?.status !== 'BOOKED'}
                  options={coordinatorOptions}
                  allowClear
                />
              </Form.Item>
              {!isMakupSession && (
                <Form.Item name='mainTeacherId' label={t('page.class.label.teacher_teaching')}>
                  <Input disabled />
                </Form.Item>
              )}
              <Form.Item label={t('page.class.label.real_teacher')}>
                {(teacherSchedule?.teacherUsername || teacherSchedule?.userName) && (
                  <a className='m-3' style={{ textDecoration: 'none', cursor: 'default' }}>
                    {teacherSchedule.teacherUsername || teacherSchedule.userName}
                  </a>
                )}
                <Button
                  disabled={!editable || !scheduleDate || !classTimeSlotId}
                  onClick={handleOpenModalReasonChangeTeacher}
                >
                  {t('page.class.text.select_teacher')}
                </Button>
              </Form.Item>
              <Form.Item
                label='Tài khoản Classin'
              >
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                  <div>
                    <div className='d-flex align-items-center'>
                      {
                        phone && (
                          <>
                            <span>{callingCode && callingCode} {phone && phone}</span>
                            <Button
                              icon={<CopyOutlined />}
                              style={{ border: 'none' }}
                              className='d-flex align-items-center justify-content-center mr-1'
                              onClick={() => {
                                copy(phone)
                                notification.success({ message: 'Copy thành công!' })
                              }}
                            />
                          </>
                        )
                      }
                    </div>
                    <span
                      style={{ color: colorClassInStatus[classData?.classInAcctSearchStatus] }}
                    >
                      {t(`constant.class_in_status.${classData?.classInAcctSearchStatus}`)}
                    </span>
                  </div>
                  <Form.Item label='Link vào lớp' className='margin-antd-form-zero' style={{ alignItems: 'baseline' }}>
                    {
                      isShowButtonEnterClass({
                        classTimeSlotId: classData?.classTimeSlotId,
                        learnDate: classData?.learnDate,
                        teacherId: classData?.teacherId
                      })
                        ? (
                          <div className='d-flex align-items-center'>
                            <Link
                              href={`${URL_TEMPLATE.REDIRECT_ENTER_CLASS}?sessionId=${classData?.id}&sessionType=${sessionType}`}>Link</Link>
                            <Button
                              icon={<CopyOutlined />}
                              style={{ border: 'none' }}
                              className='d-flex align-items-center justify-content-center mr-1'
                              onClick={() => {copy(`${baseUrl}${URL_TEMPLATE.REDIRECT_ENTER_CLASS}?sessionId=${classData?.id}&sessionType=${sessionType}`)}}
                            />
                          </div>
                        ) : <></>
                    }
                  </Form.Item>
                </div>
              </Form.Item>
            </Col>
          </Row>
          {editable && (
            <Row justify='center'>
              <Button type='primary' htmlType='submit' loading={isSubmitting} className='mt-3'>
                {t('page.class.label.update')}
              </Button>
            </Row>
          )}
        </Form>
      </Spin>
      <Divider className={editable ? 'my-3' : 'mb-3 mt-0'} />
      <div className='px-3'>
        <AddComment callRequest={handleAddComment} handleReload={handleReload} />
        <Comments notes={classData?.notes} />
      </div>
      <Modal title='Cập nhật buổi học' onCancel={handleClose} visible={isModalVisible} footer={null}>
        {content}
      </Modal>
      {isModalVisibleTeacher && (
        <ModalSelectTeacherOfSession
          setTeacherSchedule={setTeacherSchedule}
          handleClose={handleCloseTeacher}
          filterTeacher={filterTeacher}
          studentIds={studentIds}
          classData={classData}
        />
      )}
      <ReasonChangeTeacher
        setNoteChangTeacher={setNoteChangTeacher}
        waitingConfirmId={waitingConfirmId}
        handleClose={handleCloseReasonChangeTeacher}
        visible={isModalVisibleReasonChangeTeacher}
        submitReasonChangeTeacher={handleOpenModalTeacher}
      />
    </CollapseBlock>
  )
}

const ReasonChangeTeacher = ({
  waitingConfirmId,
  submitReasonChangeTeacher,
  setNoteChangTeacher,
  handleClose,
  visible
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const handleCancel = () => {
    form.resetFields()
    handleClose()
  }

  const callRequest = (values) => {
    setNoteChangTeacher({
      id: waitingConfirmId,
      note: values.note
    })

    handleClose()
    submitReasonChangeTeacher()
  }

  return (
    <ModalForm
      visible={visible}
      form={form}
      title={t('page.class.label.waiting_confirm_change_teacher')}
      callRequest={callRequest}
      onCancel={handleCancel}
      confirmOnly
      okText={t('common.label.agree')}
    >
      <Form
        form={form}
        initialValues={{}}
      >
        <p>{t('page.class.text.waiting_confirm_change_teacher')}</p>
        <Form.Item name='note' rules={[{ required: true, message: <span>{t('common.text.field_required')}</span> }]}>
          <TextArea rows={4} showCount placeholder={t('common.label.note_take')} maxLength={100} />
        </Form.Item>
      </Form>
    </ModalForm>
  )
}

export const formItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 6
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 16
    }
  }
}
